import { render } from "./MultiSelect.vue?vue&type=template&id=e85a8e24"
import script from "./MultiSelect.vue?vue&type=script&lang=js"
export * from "./MultiSelect.vue?vue&type=script&lang=js"

import "./MultiSelect.vue?vue&type=style&index=0&id=e85a8e24&lang=css"
script.render = render

export default script